
import React from 'react';

import LockIcon from './svgs/lock.inline.svg';

import * as styles from './styles.module.scss';

const Private = () => {
	return (
		<div className={styles.wrapper}>
			<LockIcon className={styles.lock} />
			<div className={styles.text}>
				<em>This is a private event.</em> Private events are
				often not accessible to the general public. You may be
				denied service if you have not been invited by the host.
			</div>
		</div>
	);
};

export default Private;
